import { Component, OnInit, ViewChild,Input } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ExcursionServiceService } from 'src/app/service/excursion-service.service';
import * as CryptoJS from 'crypto-js';
import { environment } from  '../../../environments/environment';
// import { ExcursionServiceService } from 
//import { ToolbarService, LinkService, ImageService, HtmlEditorService } from '@syncfusion/ej2-angular-richtexteditor';
@Component({
  selector: 'app-email',
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.css'],
  //providers: [ToolbarService, LinkService, ImageService, HtmlEditorService]
})
export class EmailComponent implements OnInit {
  constructor(private excursionServiceService:ExcursionServiceService,private router: Router,private toastrService: ToastrService,) { }
  appClient: string = environment.appClient;
  mail_data:any
  htm=''
  mail_to=''
  mail_sub=''
  supplei_name=''
  mail_from=''
  mail_pwd=''
  smtp_server=''
  smtp_port=''
  suppConfLink = ''
  ngOnInit(): void {
    let data_lis:any=this.excursionServiceService.getitem()
    this.mail_data=data_lis.list_item

    console.log(this.mail_data)
    // if(this.mail_data['requestid']!=''){
     
    // }
  }
  content = '<h1>Hello world</h1>';
  changesupplier(event:any){
    console.log(event)
    this.load_email(event)
  }
  onChange($event: any): void {
    ////console.log("onChange");
    //this.log += new Date() + "<br />";
  }

  load_RoyalAdventureEmailTemplate(data: any){
    this.htm = "";
    this.htm += '<p>Ref ID: '+ data.base_info[0].requestid +'</p>';
    this.htm += '<p>Guest Name: '+ data.base_info[0].guestname +'</p>';

    this.htm += '<table style="border-collapse: collapse; border: 1px solid black;">';
    this.htm += '<tr>';
    this.htm += '<td style="border: 1px solid black; width: 200px;">Particulars</td>';
    this.htm += '<td style="border: 1px solid black; width: 100px;">Unit</td>';
    this.htm += '<td style="border: 1px solid black; width: 100px;">Adult</td>';
    this.htm += '<td style="border: 1px solid black; width: 100px;">Child</td>';
    this.htm += '<td style="border: 1px solid black; width: 100px;">Child Age</td>';
    this.htm += '</tr>';
    this.htm += '<tr>';
    this.htm += '<td style="border: 1px solid black;">'+ data.base_info[0].sp_name +'</td>';
    this.htm += '<td style="border: 1px solid black;">'+ data.base_info[0].units +'</td>';
    this.htm += '<td style="border: 1px solid black;">'+ data.base_info[0].adults +'</td>';
    this.htm += '<td style="border: 1px solid black;">'+ data.base_info[0].child +'</td>';
    this.htm += '<td style="border: 1px solid black;">'+ data.base_info[0].childages +'</td>';
    this.htm += '</tr>';
    this.htm += '</table>';
    this.htm += '<br/>';
    this.htm += '<p>Service: '+ data.base_info[0].sm_name +'</p>';
    this.htm += '<p>Service Date: '+ data.base_info[0].excdate +'</p>';
  }

  load_RoyalAdventureEmailTemplate_New(data: any){

    let guest:string = "";

    if(data.member_info != undefined){
      if(data.member_info.length > 0){
        for(let i=0; i < data.member_info.length; i++){
          guest += data.member_info[i].Guestname + ", ";
        }
      }
    }

    this.htm = "";
    this.htm += '<table cellpadding="0" cellspacing="0" border="0">';
                  
    this.htm += '<tr><td class="content-block"><h4 id="pro_name">Greetings from ' + data.base_info[0].CompanyName + '</h4></td></tr>';
    //this.htm += '<tr><td class="content-block">Greetings from <b>'+ data.base_info[0].CompanyName +'</b></td></tr>';
    //this.htm += '<tr><td class="content-block">Requesting you to please book and confirm the below service through our online link provided.</td></tr>';
    this.htm += '<tr><td>Please accept this booking with Ref. No. <b>'+ data.base_info[0].requestid + '</b> as a confrimed booking.</td></tr>';
    
    this.htm += '</table><br />';


    this.htm += '<table class="invoice-items" style="border:1px solid #808080;padding:5px;" cellpadding="0" cellspacing="0">';
    this.htm += '<thead style="border:1px solid #808080;padding:5px;"><tr><th colspan="2" style="border:1px solid #808080;padding:5px;text-align:center;color:#0094ff">Tour Service Details</th></tr></thead>';
    this.htm += '<tbody style="border:1px solid #808080;padding:5px;">';
    this.htm += '<tr style="border:1px solid #808080;padding:5px;">';
    
    if(data.base_info[0].is_multicost == 1 && data.base_info[0].is_parent == 0) {
      this.htm += '<td style="border:1px solid #808080;padding:5px;"><b id="service_name">' + data.base_info[0].sm_name + ' - ' + data.base_info[0].sm_name + '</b></td>';
    }
    else {
      this.htm += '<td style="border:1px solid #808080;padding:5px;"><b id="service_name">' + data.base_info[0].sm_name + '</b></td>';
    }

    this.htm += '<td class="" style="border:1px solid #808080;padding:5px;">';
    this.htm += '<b id="req_date">Service Date: ' + data.base_info[0].excdate + '</b>';

    if (data.base_info[0].sm_type == '2') {
      this.htm += '<br />Pickup Time : ' + data.base_info[0].pickup + '';
      this.htm += '<br />Drop off Time' + data.base_info[0].drop_off + '';
    }
    else {
      this.htm += '<br />Start Time : <b>' + data.base_info[0].starttime + '</b>';
      this.htm += '<br />End Time : <b>' + data.base_info[0].endtime + '</b>';
    }
    this.htm += '</td>';
    this.htm += ' </tr>';
    var mhtm = "";
    
    this.htm += '<tr style="border:1px solid #808080">';
    this.htm += '<td style="border:1px solid #808080;padding:5px;">Guest Name</td>';
    this.htm += '<td style="border:1px solid #808080;padding:5px;" class="">' + guest + '</td>';

    if (data.hotel_info.length>0) {
      if (data.hotel_info != "NONE" && data.hotel_info[0].partyname != "OTHER SERVICES PROVIDER" && data.hotel_info[0].partyname != "Unavailable") {
        this.htm += '<tr style="border:1px solid #808080">';
        this.htm += '<td style="border:1px solid #808080;padding:5px;">Pickup Location</td>';
        this.htm += '<td style="border:1px solid #808080;padding:5px;" class=""><b>' + data.hotel_info[0].partyname + '</b><br />' + data.hotel_info[0].add1 + ',' + data.hotel_info[0].add2 + '</td>';
        this.htm += ' </tr>';
      }
    }
    else {
      if (data.base_info.length>0) {
        if (data.base_info[0].pickup_location != "Unavailable") {
          this.htm += '<tr style="border:1px solid #808080">';
          this.htm += '<td style="border:1px solid #808080;padding:5px;">Pickup Location</td>';
          this.htm += '<td style="border:1px solid #808080;padding:5px;" class=""><b>' + data.base_info[0].pickup_location + '</b></td>';
          this.htm += ' </tr>';
        }
        else {
          this.htm += '<tr style="border:1px solid #808080">';
          this.htm += '<td style="border:1px solid #808080;padding:5px;">Pickup Location</td>';
          this.htm += '<td style="border:1px solid #808080;padding:5px;" class=""><b>Unavailable</b></td>';
          this.htm += ' </tr>';
        }
      }
    }

    this.htm += '<tr style="border:1px solid #808080">';
    this.htm += '<td style="border:1px solid #808080;padding:5px;">No of Traveler(s)</td>';

    var childage = '';
    if (data.base_info[0].is_multicost == 1 && data.base_info[0].is_parent == 0) {
      if (data.multi_info[0].childages == '') {
        childage = '<b style="color:red">Not Specified</b>';
      }
      else {
        childage = data.multi_info[0].childages;
      }

      if (parseInt(data.multi_info[0].child) == 0) {
        this.htm += '<td style="border:1px solid #808080;padding:5px;" class="">' + mhtm + '<br />(Adult: ' + data.multi_info[0].adults + ', Child: ' + data.multi_info[0].child + ', Total: ' + data.multi_info[0].total + ')</td>';
      }
      else {
        this.htm += '<td style="border:1px solid #808080;padding:5px;" class="">' + mhtm + '<br />(Adult: ' + data.multi_info[0].adults + ', Child: ' + data.multi_info[0].child + ', Total: ' + data.multi_info[0].total + ') <br /> Child Ages : ' + childage + '</td>';
      }
    }
    else {
      if (data.base_info[0].childages == '') {
        childage = '<b style="color:red">Not Specified</b>';
      }
      else {
        childage = data.base_info[0].childages;
      }

      if (data.base_info[0].child == 0) {
        this.htm += '<td style="border:1px solid #808080;padding:5px;" class="">' + mhtm + '<br />(Adult: ' + data.base_info[0].adults + ', Child: ' + data.base_info[0].child + ', Total: ' + (parseInt(data.base_info[0].adults) + parseInt(data.base_info[0].child)) + ')</td>';
      }
      else {
        this.htm += '<td style="border:1px solid #808080;padding:5px;" class="">' + mhtm + '<br />(Adult: ' + data.base_info[0].adults + ', Child: ' + data.base_info[0].child + ', Total: ' + (parseInt(data.base_info[0].adults) + parseInt(data.base_info[0].child)) + ') <br /> Child Ages : ' + childage + '</td>';
      }
    }

    this.htm += '';
    this.htm += '';
    this.htm += ' </tr>';

    this.htm += '<tr style="border:1px solid #808080">';
    this.htm += '<td style="border:1px solid #808080;padding:5px;">Request ID</td>';
    this.htm += '<td style="border:1px solid #808080;padding:5px;" class=""><b>' + data.base_info[0].requestid + '</b></td>';
    this.htm += ' </tr>';
    
    if (data.base_info[0].ExcSupComment != "None" && data.base_info[0].ExcSupComment != "") {
      this.htm += '<tr style="border:1px solid #808080">';
      this.htm += '<td colspan="2" style="border:1px solid #808080;padding:5px;">Remarks : <b>' + data.base_info[0].ExcSupComment +'</b></td>';
      //htm += '<td style="border:1px solid #808080;padding:5px;" class=""></td>';
      this.htm += ' </tr>';
    }
    else {
      this.htm += '<tr style="border:1px solid #808080">';
      this.htm += '<td colspan="2" style="border:1px solid #808080;padding:5px;">Remarks : <b>None</b></td>';
      //htm += '<td style="border:1px solid #808080;padding:5px;" class=""></td>';
      this.htm += ' </tr>';
    }
    
    if(this.appClient != "RoyalAdventure" && this.appClient != "Mayra"){
      let conflinkdata = "";
      conflinkdata = "Excursion;" + data.base_info[0].service_id + ";" + data.base_info[0].partycode;

      let encryptedText = this.Encryption(conflinkdata);
      let encodedData = encodeURIComponent(encryptedText);

      this.htm += '<tr style="border:1px solid #808080">';
      this.htm += '<td colspan="1" style="border:1px solid #808080;padding:5px;">Confirm Service (Click On Link)</td>';
      //this.htm += '<td style="border:1px solid #808080;padding:5px;" class=""><div id="btn-toprocess"><a href="'+ this.suppConfLink + '"?q=' + data.base_info[0].service_id + '&pcode=' + data.base_info[0].partycode + '&type=1" target="_blank"><button type="button" style="background-color:#1c84c6;border:none;color:white;padding: 15px 32px;text-align:center;text-decoration:none;display:inline-block;font-size: 16px;">Respond to Service Request</button></a></div></td>';
      this.htm += '<td style="border:1px solid #808080;padding:5px;" class=""><div id="btn-toprocess"><a href="'+ this.suppConfLink + '?q=' + encodedData + '" target="_blank"><button type="button" style="background-color:#1c84c6;border:none;color:white;padding: 15px 32px;text-align:center;text-decoration:none;display:inline-block;font-size: 16px;">Respond to Service Request</button></a></div></td>';
      this.htm += ' </tr>';
    }

    this.htm += '</tbody>';
    this.htm += '</table><br />';
    
    this.htm += '<table class="invoice" style="width:100%;">';
    this.htm += '<tbody>';
    //this.htm += '<tr><td>Thanks & Regards,<br /><b>Excursion Officer</b><br /><b>'+ data.base_info[0].CompanyName  +'</b><br /><b>Tel : '+ data.base_info[0].TelePhone  +'</b><br /><b>Email : <strong style="color:#0094ff">'+ data.base_info[0].Email  +'</strong></b></td></tr>';
    this.htm += '<tr><td>Thanks & Regards,</td></tr>';
    this.htm += '<tr><td>Reservation Department</td></tr>';

    this.htm += '</tbody>';
    this.htm += '</table>';

    //console.log(this.htm);
  }

  loadEmailTemplate(data: any){
    this.htm = "";
    this.htm += '<table cellpadding="0" cellspacing="0">';
                  
    this.htm += '<tr><td class="content-block"><h4 id="pro_name">' + data.base_info[0].sp_name + ',</h4></td></tr>';
    this.htm += '<tr><td class="content-block">Greetings from <b>'+ data.base_info[0].CompanyName +'</b></td></tr>';
    this.htm += '<tr><td class="content-block">Requesting you to please book and confirm the below service through our online link provided.</td></tr>';
    // this.htm += '<tr><td>Thanks & Regards,<br /><b>Excursion Officer</b><br /><b>Travel Saga Tourism</b><br /><b>Tel : +971 4 268 4645</b><br /><b>Email : <strong style="color:#0094ff">info@travelsaga.com</strong></b></td></tr>';
    
    this.htm += '</table>';


    this.htm += '<table class="invoice-items" style="border:1px solid #808080;padding:5px;" cellpadding="0" cellspacing="0">';
    this.htm += '<thead style="border:1px solid #808080;padding:5px;"><tr><th colspan="2" style="border:1px solid #808080;padding:5px;text-align:center;color:#0094ff">Requested Service Details</th></tr></thead>';
    this.htm += '<tbody style="border:1px solid #808080;padding:5px;">';
    this.htm += '<tr style="border:1px solid #808080;padding:5px;">';
    
    if(data.base_info[0].is_multicost == 1 && data.base_info[0].is_parent == 0) {
      this.htm += '<td style="border:1px solid #808080;padding:5px;"><b id="service_name">' + data.base_info[0].sm_name + ' - ' + data.base_info[0].sm_name + '</b></td>';
    }
    else {
      this.htm += '<td style="border:1px solid #808080;padding:5px;"><b id="service_name">' + data.base_info[0].sm_name + '</b></td>';
    }

    this.htm += '<td class="" style="border:1px solid #808080;padding:5px;">';
    this.htm += '<b id="req_date">Service Date: ' + data.base_info[0].excdate + '</b>';

    if (data.base_info[0].sm_type == '2') {
      this.htm += '<br />Pickup Time : ' + data.base_info[0].pickup + '';
      this.htm += '<br />Drop off Time' + data.base_info[0].drop_off + '';
    }
    else {
      this.htm += '<br />Start Time : <b>' + data.base_info[0].starttime + '</b>';
      this.htm += '<br />End Time : <b>' + data.base_info[0].endtime + '</b>';
    }
    this.htm += '</td>';
    this.htm += ' </tr>';
    var mhtm = "";
    // $.each(obj.members, function (i, row) {

    //     mhtm += '<b>' + row.Guestname + '</b><br />';

    // });

    this.htm += '<tr style="border:1px solid #808080">';
    this.htm += '<td style="border:1px solid #808080;padding:5px;">Guest Details</td>';

    var childage = '';
    if (data.base_info[0].is_multicost == 1 && data.base_info[0].is_parent == 0) {
      if (data.multi_info[0].childages == '') {
        childage = '<b style="color:red">Not Specified</b>';
      }
      else {
        childage = data.multi_info[0].childages;
      }

      if (parseInt(data.multi_info[0].child) == 0) {
        this.htm += '<td style="border:1px solid #808080;padding:5px;" class="">' + mhtm + '<br />(Adult: ' + data.multi_info[0].adults + ', Child: ' + data.multi_info[0].child + ', Total: ' + data.multi_info[0].total + ')</td>';
      }
      else {
        this.htm += '<td style="border:1px solid #808080;padding:5px;" class="">' + mhtm + '<br />(Adult: ' + data.multi_info[0].adults + ', Child: ' + data.multi_info[0].child + ', Total: ' + data.multi_info[0].total + ') <br /> Child Ages : ' + childage + '</td>';
      }
    }
    else {
      if (data.base_info[0].childages == '') {
        childage = '<b style="color:red">Not Specified</b>';
      }
      else {
        childage = data.base_info[0].childages;
      }

      if (data.base_info[0].child == 0) {
        this.htm += '<td style="border:1px solid #808080;padding:5px;" class="">' + mhtm + '<br />(Adult: ' + data.base_info[0].adults + ', Child: ' + data.base_info[0].child + ', Total: ' + (parseInt(data.base_info[0].adults) + parseInt(data.base_info[0].child)) + ')</td>';
      }
      else {
        this.htm += '<td style="border:1px solid #808080;padding:5px;" class="">' + mhtm + '<br />(Adult: ' + data.base_info[0].adults + ', Child: ' + data.base_info[0].child + ', Total: ' + (parseInt(data.base_info[0].adults) + parseInt(data.base_info[0].child)) + ') <br /> Child Ages : ' + childage + '</td>';
      }
    }

    this.htm += '';
    this.htm += '';
    this.htm += ' </tr>';

    if (data.hotel_info.length>0) {
      if (data.hotel_info != "NONE" && data.hotel_info[0].partyname != "OTHER SERVICES PROVIDER" && data.hotel_info[0].partyname != "Unavailable") {
        this.htm += '<tr style="border:1px solid #808080">';
        this.htm += '<td style="border:1px solid #808080;padding:5px;">Pickup Location</td>';
        this.htm += '<td style="border:1px solid #808080;padding:5px;" class=""><b>' + data.hotel_info[0].partyname + '</b><br />' + data.hotel_info[0].add1 + ',' + data.hotel_info[0].add2 + '</td>';
        this.htm += ' </tr>';
      }
    }
    else {
      if (data.base_info.length>0) {
        if (data.base_info[0].pickup_location != "Unavailable") {
          this.htm += '<tr style="border:1px solid #808080">';
          this.htm += '<td style="border:1px solid #808080;padding:5px;">Pickup Location</td>';
          this.htm += '<td style="border:1px solid #808080;padding:5px;" class=""><b>' + data.base_info[0].pickup_location + '</b></td>';
          this.htm += ' </tr>';
        }
        else {
          this.htm += '<tr style="border:1px solid #808080">';
          this.htm += '<td style="border:1px solid #808080;padding:5px;">Pickup Location</td>';
          this.htm += '<td style="border:1px solid #808080;padding:5px;" class=""><b>Unavailable</b></td>';
          this.htm += ' </tr>';
        }
      }
    }

    this.htm += '<tr style="border:1px solid #808080">';
    this.htm += '<td style="border:1px solid #808080;padding:5px;">Request ID</td>';
    this.htm += '<td style="border:1px solid #808080;padding:5px;" class=""><b>' + data.base_info[0].requestid + '</b></td>';
    this.htm += ' </tr>';

    
    if(this.appClient == "RoyalPark"){
      this.htm += '<tr style="border:1px solid #808080">';
      this.htm += '<td style="border:1px solid #808080;padding:5px;">Voucher No</td>';
      this.htm += '<td style="border:1px solid #808080;padding:5px;" class=""><b>' + data.base_info[0].VoucherNo + '</b></td>';
      this.htm += ' </tr>';
    }
    
    if (data.base_info[0].ExcSupComment != "None" && data.base_info[0].ExcSupComment != "") {
      this.htm += '<tr style="border:1px solid #808080">';
      this.htm += '<td colspan="2" style="border:1px solid #808080;padding:5px;">Remarks : <b>' + data.base_info[0].ExcSupComment +'</b></td>';
      //htm += '<td style="border:1px solid #808080;padding:5px;" class=""></td>';
      this.htm += ' </tr>';
    }
    else {
      this.htm += '<tr style="border:1px solid #808080">';
      this.htm += '<td colspan="2" style="border:1px solid #808080;padding:5px;">Remarks : <b>None</b></td>';
      //htm += '<td style="border:1px solid #808080;padding:5px;" class=""></td>';
      this.htm += ' </tr>';
    }
    
    if(this.appClient != "RoyalAdventure" && this.appClient != "Mayra"){
      let conflinkdata = "";
      conflinkdata = "Excursion;" + data.base_info[0].service_id + ";" + data.base_info[0].partycode;

      let encryptedText = this.Encryption(conflinkdata);
      let encodedData = encodeURIComponent(encryptedText);

      this.htm += '<tr style="border:1px solid #808080">';
      this.htm += '<td colspan="1" style="border:1px solid #808080;padding:5px;">Confirm Service (Click On Link)</td>';
      //this.htm += '<td style="border:1px solid #808080;padding:5px;" class=""><div id="btn-toprocess"><a href="'+ this.suppConfLink + '"?q=' + data.base_info[0].service_id + '&pcode=' + data.base_info[0].partycode + '&type=1" target="_blank"><button type="button" style="background-color:#1c84c6;border:none;color:white;padding: 15px 32px;text-align:center;text-decoration:none;display:inline-block;font-size: 16px;">Respond to Service Request</button></a></div></td>';
      this.htm += '<td style="border:1px solid #808080;padding:5px;" class=""><div id="btn-toprocess"><a href="'+ this.suppConfLink + '?q=' + encodedData + '" target="_blank"><button type="button" style="background-color:#1c84c6;border:none;color:white;padding: 15px 32px;text-align:center;text-decoration:none;display:inline-block;font-size: 16px;">Respond to Service Request</button></a></div></td>';
      this.htm += ' </tr>';
    }

    //htm += '<tr style="border:1px solid #808080">';
    //htm += '<td style="border:1px solid #808080;padding:5px;">Pickup Location</td>';
    //htm += '<td style="border:1px solid #808080;padding:5px;" class="">' + obj.base_info[0].othtypname + '</td>';
    //htm += ' </tr>';

    this.htm += '</tbody>';
    this.htm += '</table>';
    
    this.htm += '<table class="invoice" style="width:100%;">';
    this.htm += '<tbody>';

    //this.htm += '<tr><td>Thanks & Regards,<br /><b>Excursion Officer</b><br /><b>Travel Saga Tourism</b><br /><b>Tel : +971 4 268 4645</b><br /><b>Email : <strong style="color:#0094ff">info@travelsaga.com</strong></b></td></tr>';
    this.htm += '<tr><td>Thanks & Regards,<br /><b>Excursion Officer</b><br /><b>'+ data.base_info[0].CompanyName  +'</b><br /><b>Tel : '+ data.base_info[0].TelePhone  +'</b><br /><b>Email : <strong style="color:#0094ff">'+ data.base_info[0].Email  +'</strong></b></td></tr>';

    this.htm += '</tbody>';
    this.htm += '</table>';
  }

  load_email(data:any){
    console.log(data);
    let serviceId: number = 0;

    if(this.appClient == "RoyalAdventure"){
      serviceId = data.service_ref_id;
    }
    else{
      serviceId = data.service_id;
    }

    let va = {
      "requestid": data.requestid,
      "service_id": serviceId,
      "is_multicost": data.is_multicost
    }
    this.excursionServiceService.get_mail_data(va).subscribe(r=>{

      if (r['result'] == 1) {
        this.mail_from = r['data'].base_info[0].EmailFrom;
        this.mail_pwd = r['data'].base_info[0].EmailPwd;
        this.smtp_server = r['data'].base_info[0].SmtpServer;
        this.smtp_port = r['data'].base_info[0].SmtpPort;
        this.suppConfLink = r['data'].base_info[0].SuppConfLink;
        this.mail_to = r['data'].base_info[0].EmailTo;

        if(this.appClient == "RoyalPark" || this.appClient == "RoyalAdventure"){
          this.mail_sub = r['data'].base_info[0].subject;
        }

        if(this.appClient == "RoyalAdventure"){
          this.load_RoyalAdventureEmailTemplate_New(r['data']);
        }
        else{
          this.loadEmailTemplate(r['data']);
        }
      }
      else{

      }
      
    })
  }

sendmail(){

  let toAddress:any = []

  let toAdd = this.mail_to.split(",");

  if(toAdd.length > 0){
    for(let i=0; i < toAdd.length; i++){
      toAddress.push(toAdd[i]);
    }
  }

  const send_data={
    "html_body" : this.htm,
    "sub" : this.mail_sub,
    "email_to" : toAddress,
    "email_from" : this.mail_from,
    "email_pwd" : this.mail_pwd,
    "smtp_server" : this.smtp_server,
    "smtp_port" : this.smtp_port
  }
  console.log(send_data);
  this.excursionServiceService.smtp_mail_send(send_data).subscribe(res=>{
    ////console.log(res)
    // this.router.navigate(['/webqnex/excursion']);
    this.toastrService.success('Mail Send Successfully', 'Title Success!',{closeButton:true, timeOut: 3000});
  })
}

Encryption(text: string): string{
  let encryptedText: string = "";
  const key = 'supConfNum@@2024';
  encryptedText = CryptoJS.AES.encrypt(text, key).toString();
  //console.log('Encrypted text:', encryptedText);
  return encryptedText;
}

reset(){
  this.router.navigate(['/webqnex/excursion']);
  // this.htm=''
  // this.mail_to=''
  // this.mail_sub=''
}
  onPaste($event: any): void {
    ////console.log("onPaste");
    //this.log += new Date() + "<br />";
  }
  handleEvent(event:any){
    ////console.log(event.editor.value)
    ////console.log(event.args)
  }
}
